import { render, staticRenderFns } from "./invisiblePhotoUploader.vue?vue&type=template&id=670c0848&scoped=true&"
import script from "./invisiblePhotoUploader.vue?vue&type=script&lang=js&"
export * from "./invisiblePhotoUploader.vue?vue&type=script&lang=js&"
import style0 from "./invisiblePhotoUploader.vue?vue&type=style&index=0&id=670c0848&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c0848",
  null
  
)

export default component.exports